import React from 'react';
import PropTypes from 'prop-types';

import {ButtonGhostIcon} from 'pac-ux-components';

import {AiOutlineClear} from 'react-icons/ai';

import {I18n} from '@aws-amplify/core';

import {Box, Center, Grid} from '@mantine/core';

export const ActionsControl = ({ label, resourceCount, onClickHandler }) => (
    <Grid>
        <Grid.Col xs={12} sm={6}>
            <Box variant="h4" mt="xl">
                {I18n.get(label)}:
            </Box>
        </Grid.Col>
        <Grid.Col xs={12} sm={2}>
            <Box variant="h4" mt="xl">
                <Center>{resourceCount}</Center>
            </Box>
        </Grid.Col>

        <Grid.Col xs={12} sm={4}>
            <Center mt="sm">
                {resourceCount > 0 ? (
                    <ButtonGhostIcon
                        type="button"
                        icon={<AiOutlineClear />}
                        onClick={onClickHandler}
                        tabIndex={4}
                    >
                        {I18n.get('Clear All')}
                    </ButtonGhostIcon>
                ) : null}
            </Center>
        </Grid.Col>
    </Grid>
);

ActionsControl.propTypes = {
    label: PropTypes.string.isRequired,
    resourceCount: PropTypes.number.isRequired,
    onClickHandler: PropTypes.func.isRequired,
};
